/** Clock display: 1-second resolution, ceiling so 0:00 means truly out (F-8). */
export function formatClock(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Seconds → "1:30 min" style label for config UI. */
export function formatDuration(ms: number): string {
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  const rest = s % 60;
  return rest === 0 ? `${m} min` : `${m}:${String(rest).padStart(2, '0')} min`;
}

/**
 * Playhead / elapsed display for the playback transport: floored, because a
 * position of 3:41.9 is still 3:41 — unlike the clocks, which ceil so that
 * 0:00 means truly out of time.
 */
export function formatTimecode(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
